/**
 * 技术信息表单组件
 * 用于收集用户的技术相关信息
 *
 * @component TechnicalInfoForm
 * @emits submit - 表单提交事件
 * @emits update - 表单更新事件
 */
<template>
  <div class="collapsible-section" id="技术信息">
    <div class="collapsible-header" @click="toggleTechnicalInfo">
      <div class="header-left">
        <el-icon :size="24" :class="{ 'header-arrow': !showTechnicalInfo }">
          <svg-icon name="arrow-active" />
        </el-icon>
        <span class="header-title">技术信息</span>
        <span class="header-tip">内容由AI生成，仅供辅助参考</span>
        <el-tag size="small" type="info" class="field-count">6 个字段</el-tag>
      </div>
    </div>

    <div class="collapsible-content" :class="{ 'expanded': showTechnicalInfo }">
      <template v-for="item in filteredInfoArr" :key="item.key">
        <div :id="item.key" :class="{ 'form-item': true, 'expand': expandProp[item.key], 'error': showError && !formData[item.key] }" :ref="item.ref">
          <label @click="() => onExpand(item.key)">
            <el-icon :size="24" class="label-arrow">
              <svg-icon name="arrow" />
            </el-icon>
            {{ item.title }}
            <span class="required" v-if="item.required">*</span>
            <div v-if="reasonData?.[item.key]" class="reason" @click.stop="() => reasonGeneratingFields[item.key] ? null : reasonExpand[item.key] = !reasonExpand[item.key]">
              {{ reasonGeneratingFields[item.key] ? '思考中...' : `已深度思考` }}
              <template v-if="!reasonGeneratingFields[item.key] && reasonTime[item.key]">{{ `（用时${Math.ceil(reasonTime[item.key] / 1000)}秒）` }}</template>
              <el-icon :size="14" class="reason-arrow">
                <ArrowUp v-if="reasonExpand[item.key]" />
                <ArrowDown v-else />
              </el-icon>
            </div>
          </label>
          <div class="reason-text" v-if="reasonData?.[item.key] && reasonExpand[item.key]">{{ reasonData?.[item.key] }}</div>
          <div class="textarea-wrapper" v-if="!reasonGeneratingFields[item.key] && item.key !== 'termInterpretation'">
            <!-- <textarea
              rows="3"
              :data-field="'background'"
              v-model="formData.background"
              @input="handleInput('background', $event.target.value)"
              placeholder="请描述本发明所属技术领域的现有技术水平、存在的技术问题等背景信息"
            ></textarea> -->
            <HighlightTextArea
              :disabled="disabled"
              :value="formData[item.key]"
              :highlight="getHighlight(item.key)"
              :placeholder="item.placeholder"
              @input="handleInput(item.key, $event)"
              @blur="handleBlur(item.key,item.title)"
              @focus="handleFocus(item.key)"
            />
            <button
              v-if="isButtonVisible(item.key)"
              class="confirm-button"
              @click="handleConfirmAndContinue(item.key)"
            >
              确认并继续撰写
            </button>
          </div>
          <div class="term-interpretation-content" v-if="item.key === 'termInterpretation'">
            <el-table :data="parsedItems" bordered style="width: 100%" :header-cell-style="{ textAlign: 'center' }">
              <el-table-column prop="term" label="术语" width="180">
                <template #default="scope">
                   <el-input v-model="scope.row.term" style="width: 100%" @input="handleTermleInput()"   />
                </template>
              </el-table-column>
              <el-table-column prop="english" label="英文表达" width="180">
                 <template #default="scope">
                   <el-input v-model="scope.row.english" style="width:100%" @input="handleTermleInput()"  />
                </template>
              </el-table-column>
              <el-table-column prop="explanation" label="术语解释" >
                <template #default="scope">
                   <el-input v-model="scope.row.explanation" style="width: 100%" @input="handleTermleInput()" />
                </template>
              </el-table-column>
               <el-table-column prop="operation" label="操作" width="80">
                <template #default="scope">
                  <el-space wrap :size="16">
                    <el-icon  @click="handleAddRow(scope.$index)"><Plus /></el-icon>
                    <el-icon @click="handleDeleteRow(scope.$index)"><Minus /></el-icon>
                  </el-space>
                  </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="hover-panel" v-if="!disabled">
            <button class="hover-btn" @click.stop="showAIPanel = item.key" v-if="isAIVisible(item.key)">
            <el-icon :size="14" class="hover-btn-icon"><svg-icon name="writing/ai" /></el-icon>
            <el-icon :size="14" class="hover-btn-icon-active"><svg-icon name="writing/ai-active" /></el-icon>
            AI助手
          </button>
            <button class="hover-btn" @click.stop="handleRewrite(item.key,item.title)" v-if="!isStreamingField(item.key)">
              <el-icon :size="12" class="hover-btn-icon"><svg-icon name="writing/refresh" /></el-icon>
              <el-icon :size="12" class="hover-btn-icon-active"><svg-icon name="writing/refresh-active" /></el-icon>
              重写
            </button>
            <button class="hover-btn" @click.stop="handlePolish(item.key,item.title)" v-if="!isStreamingField(item.key)">
              <el-icon :size="12" class="hover-btn-icon"><svg-icon name="writing/runse" /></el-icon>
              <el-icon :size="12" class="hover-btn-icon-active"><svg-icon name="writing/runse-active" /></el-icon>
              润色
            </button>
            <button class="hover-btn" @click.stop="handleLike(item.key)" v-if="!isStreamingField(item.key)">
              <el-icon :size="12" class="hover-btn-icon"><svg-icon name="writing/like" /></el-icon>
              <el-icon :size="12" class="hover-btn-icon-active"><svg-icon name="writing/like-active" /></el-icon>
              点赞
            </button>
          </div>
          <div class="upload-section" v-loading="isRecognizing" element-loading-text="正在识别图片内容..." v-if="item.key === 'description'">
            <!-- Mermaid流程图生成区域 -->
            <div class="mermaid-section" v-if="props.currentStep==1">
              <button  class="mermaid-generate-btn"  @click="handleGenerateMermaid" :disabled="!formData[item.key]">
                <el-icon :size="14" class="mermaid-btn-icon">
                  <svg-icon name="writing/ai" />
                </el-icon>
                生成流程图
              </button>
            </div>
            <div v-for="(file, index) in formData.imageUrls" :key="index" v-loading="file.loading" class="upload-image">
              <div class="image-title">{{ `图片${index+1}` }}</div>
              <HighlightTextArea
                v-if="file.content"
                :disabled="disabled"
                :value="file.content"
                @input="handleImageInput(index, $event)"
              />
              <div class="image-item">
                <el-image
                  v-if="file.url"
                  :src="file.url"
                  :preview-src-list="formData.imageUrls.map(v => v.url)"
                  :initial-index="index"
                  fit="scale-down"
                />
                <el-icon v-if="file.url && !disabled" class="image-close" @click.stop="() => handleRemoveImage(index)"><CircleCloseFilled /></el-icon>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="extract-file">
      <div v-for="(item, index) in extractedSourceFile" :key="index">
        {{ item.filename }}
      </div>
    </div>
    <!-- AI助手面板 -->
    <AIAssistant
      ref="AIAssistantRef"
      v-model="showAIPanel"
      :formData="formData"
      :field="showAIPanel"
      @select="handleSelectAI"
      @update="handleHistoryUpdate"
    />
    <imgDialog
      ref="imgDialogRef"
    />
    <!-- Mermaid流程图弹框 -->
    <MermaidDialog
      v-model="showMermaidDialog"
      :content="formData.description"
      :projectId="projectId"
      @close="handleDialogClose"
      @save="handleMermaidSave"
    />

  </div>
</template>

<script setup>
import {ref, defineProps, defineEmits, watch, nextTick, unref, computed} from 'vue'
import { Tools, ArrowDown, Refresh, MagicStick, Plus,Minus, ArrowUp, CircleCloseFilled, CopyDocument, Delete, Loading, Download } from '@element-plus/icons-vue'
import { ElMessage, ElLoading, ElSpace } from 'element-plus'
import HighlightTextArea from './HighlightTextArea.vue'
import { useRoute } from 'vue-router'
import { fetchUpload, fetchDeleteFile,fetchRecordAdd } from '@/api/project'
import { fetchLike, fetchSaveActionValue } from '@/api/writing'
import AIAssistant from '../AIAssistant.vue'
import imgDialog from '@/views/Writing/imgDialog'
import {eventBus} from "@/utils/mitt";
import MermaidDialog from '../dialogs/MermaidDialog.vue'
const imgDialogRef = ref()
const parsedItems = ref([])




const imgClick = (data) =>{
    imgDialogRef.value.open(data)
}

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  showError: {
    type: Boolean,
    default: false
  },
  extractedSourceFile: {
    type: Object,
  },
  isOutlineStep: {
    type: Boolean,
    default: false
  },
  getStepParams: {
    type: Function,
    default: () => ({})
  },  savedFormData: {
    type: Object,
    default: null
  },
  // 添加新的prop来控制重置
  shouldReset: {
    type: Boolean,
    default: false
  },
  isAuto: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  projectId: {
    type: String,
    default: ''
  },
  generatingFields: {
    type: Object,
    default: () => ({})
  },
  reasonData: {
    type: Object,
    default: null
  },
  reasonGeneratingFields: {
    type: Object,
    default: () => ({})
  },
  reasonExpand: {
    type: Object,
    default: () => ({})
  },
  reasonTime: {
    type: Object,
    default: () => ({})
  },
  currentStep: {
    type: Number,
    default: 0
  },
  generateHighlight: {
    type: Object,
    default: () => ({})
  },
  termInterpretation: {
    type: String,
    default: ''
  },
})

watch(
  () => props.termInterpretation,
  (jsonData) => {
    if (!jsonData) {
      parsedItems.value = [];
      return;
    }
    try {
      parsedItems.value = JSON.parse(jsonData);
    } catch (e) {
      console.error('JSON解析错误:', e);
      parsedItems.value = [];
    }
  }
)
const handleAddRow = (index) => {
  const newItems = [...parsedItems.value];
  newItems.splice(index + 1, 0, {
    term: '',
    explanation: '',
    interpretation: ''
  });
  formData.value.termInterpretation = JSON.stringify(newItems);
  emit('update:modelValue', { ...formData.value })
};
const handleDeleteRow = (index) => {
  const newItems = [...parsedItems.value];
  newItems.splice(index, 1);
  formData.value.termInterpretation = JSON.stringify(newItems);
  emit('update:modelValue', { ...formData.value })
};
const handleTermleInput = (index) => {
  const newItems = [...parsedItems.value];
  formData.value.termInterpretation = JSON.stringify(newItems);
  emit('update:modelValue', { ...formData.value })
}
const currentStepList = ['内容录入','要点提纲', '初版生成','确稿留存']
const currentStepEng = ['step1','step2','step3','step4']
const emit = defineEmits(['update:modelValue', 'field-modified', 'scroll-to', 'streaming-status', 'generating-status', 'score-update', 'history-update', 'reason-status', 'reason-update'])


const route = useRoute();


// 状态管理
const chartContainer = ref(null);
const isRendering = ref(false);
const isRendered = ref(false);
const errorMessage = ref('');

// 存储每个字段的旧值和新值，用于失焦时比较
const fieldOldValues = ref({});
const fieldNewValues = ref({});

// 导入 md5 库用于生成哈希值
import md5 from 'md5';
// Mermaid 相关状态
const showMermaidDialog = ref(false) // 控制弹框显示

// 流程图定义
const flowchartDefinition = `
  flowchart TD
    A[开始] --> B[输入用户名和密码]
    B --> C{验证信息有效性}
    C -->|是| D[登录成功]
    C -->|否| E[提示错误信息]
    E --> B
    D --> F[结束]
`;

const uploadAbortController = ref({})
const scoreAbortController = ref(null)
const generateAbortController = ref({})
const AIAssistantRef = ref()
const likeEnable = false
// 添加字段引用
const backgroundField = ref(null)
const problemField = ref(null)
const technicalField = ref(null)
const effectField = ref(null)
const termInterpretationField = ref(null)
const implementationField = ref(null)
const descriptionField = ref(null)

const infoArr = [{
  key: 'background',
  title: '背景技术',
  ref: backgroundField,
  placeholder: '请描述本发明所属技术领域的现有技术水平、存在的技术问题等背景信息',
  required: true
}, {
  key: 'problem',
  title: '技术问题',
  ref: problemField,
  placeholder: '请描述本发明要解决的具体技术问题，包现有术的不足之处',
  required: true
}, {
  key: 'technical',
  title: '技术方案',
  ref: technicalField,
  placeholder: '请详细描述本发明的技术方案，包括技术特征、实现步骤等核心内容',
  required: true
}, {

  key: 'effect',
  title: '有益效果',
  ref: effectField,
  placeholder: '请描述采用本发明技术方案所能达到的有益效果，包括技术改进、性能提升等'
}, {

  key: 'implementation',
  title: '具体实施方式',
  ref: implementationField,
  placeholder: '请详细描述本发明的具体实施方式，包括实施例、具体步骤、参数等详细信息'
}, {
  key: 'termInterpretation',
  title: '术语解释',
  ref: termInterpretationField,
  placeholder: '请详细描述本发明的具体实施方式，包括实施例、具体步骤、参数等详细信息'
},
  {
  key: 'description',
  title: '附图及简要说明',
  ref: descriptionField,
  placeholder: '请输入附图的简要说明，包括图示内容、结构说明等',
}]

const filteredInfoArr = computed(() => {
  return infoArr.filter(item => {
    // 术语解释仅在第2步显示
    if (item.key === 'termInterpretation') {
      return props.currentStep === 2;
    }
    return true; // 其他字段正常显示
  });

})


watch(() => route.hash, (newVal) => {
  const searchKey = newVal.replace('#', '');
  if (expandProp.value.hasOwnProperty(searchKey)) {
    expandProp.value[searchKey] = true
  }
})

// 监听 shouldReset 的变化
watch(() => props.shouldReset, (newVal) => {
  if (newVal) {
    currentConfirmButton.value = 'technical'
    expandProp.value = {
      background: true,
      problem: true,
      technical: true,
      effect: false,
      implementation: false,
      termInterpretation:false,
      description: false
    }
    // 通知父组件流式打印状态已重置
    emit('streaming-status', false)
  }
})

// 监听 isOutlineStep 的变化
watch(() => props.isOutlineStep, (newVal) => {
  if (newVal && !props.disabled) {
    nextTick(() => {
      scrollToField(technicalField)
    })
  }
}, { immediate: true })

const showTechnicalInfo = ref(true)
const formData = ref({
  ...props.modelValue,
  imageUrls: props.modelValue.imageUrls || []
})
const expandProp = ref({
  background: true,
  problem: true,
  technical: true,
  effect: false,
  implementation: false,
  termInterpretation:false,
  description: false
});

const handleFocus = (field, oldValue) => {
  // 保存聚焦时的旧值
  fieldOldValues.value[field] = formData.value[field];
}

const handleBlur = async (field,title) => {
  // 保存失焦时的新值
  fieldNewValues.value[field] = formData.value[field];
  
  // 去除空格后生成哈希值并比较
  const oldValue = fieldOldValues.value[field] || '';
  const newValue = fieldNewValues.value[field] || '';
  
  // 去除所有空格（包括换行符、制表符等）
  const oldValueNoSpaces = oldValue.replace(/\s+/g, '');
  const newValueNoSpaces = newValue.replace(/\s+/g, '');
  
  // 生成哈希值
  const oldValueHash = md5(oldValueNoSpaces);
  const newValueHash = md5(newValueNoSpaces);
  
  // 比较哈希值
  const hasChanged = oldValueHash !== newValueHash;
  
  // 如果内容发生变化，执行相应操作
  if (hasChanged) {
    // 这里可以添加需要执行的操作，例如更新数据、发送请求等
    const opDetail = JSON.stringify({
      oldContent: oldValue,
      newContent: newValue
    })
    await fetchRecordAdd({
        projectId: props.projectId, 
        opType: "MANUAL_EDIT",
        stepName: currentStepList[props.currentStep],
        stepCode: currentStepEng[props.currentStep],
        blockCode: field,
        blockName: title,
        source: "user",
        description: "手动编辑了",
        opDetail: opDetail,
      })
  }
}


// 添加新的响应式变量来跟踪流式打印状态
const isStreaming = ref(false)

const showAIPanel = ref()

const adjustTextareaHeight = (field) => {
  nextTick(() => {
    const textarea = document.querySelector(`textarea[data-field="${field}"]`)
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    }
  })
}

// 监听表单数据变化
watch(() => props.modelValue, (newVal) => {
  formData.value = {
    ...newVal,
    imageUrls: newVal.imageUrls || []
  }
   // 调整所有文本框的高度
  Object.keys(formData.value).forEach(field => {
    if (typeof formData.value[field] === 'string') {
      adjustTextareaHeight(field)
      // 如果是可选字段且有内容，自动展开
      if (['effect', 'termInterpretation','implementation', 'description'].includes(field) && formData.value[field]) {
        expandProp.value[field] = true
      }
    }
  })
  if (newVal.imageUrls.length) {
    expandProp.value.description = true
  }
}, { deep: true, immediate: true })

watch(() => props.reasonGeneratingFields, (newVal) => {
  if (newVal) {
    Object.keys(newVal).forEach(key => {
      if (newVal[key]) {
        expandProp.value[key] = true
      }
    })
  }
}, { deep: true })

const onExpand = (key) => {
  console.log(key,'expanded',expandProp)
  expandProp.value[key] = !expandProp.value[key];
}
const toggleTechnicalInfo = () => {
  showTechnicalInfo.value = !showTechnicalInfo.value
}

const getHighlight = (key) => {
  const result = [];
  props.extractedSourceFile?.forEach(item => {
    result.push({ text: item[key], fileName: item.filename })
  })
  props.generateHighlight[key]?.forEach(item => {
    result.push(item)
  })
  return result
}

const handleInput = (field, value) => {
  formData.value[field] = value
  emit('update:modelValue', { ...formData.value })
  emit('field-modified', field, true)
  adjustTextareaHeight(field)
}

const handleImageInput = (index, value) => {
  formData.value.imageUrls[index].content = value
  emit('update:modelValue', { ...formData.value })
}

// 添加内容校验函数
const validateContent = async (field, content) => {
  const loading = ElLoading.service({
    text: '正在校验...',
    lock: true,
    background: 'rgba(255, 255, 255, 0.7)'
  })

  try {
    const params = {
      [field]: content,
      type: 'refine'
    }

    const response = await fetch('/api/contentCheck/check', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params),
    })

    if (!response.ok) {
      throw new Error('规则校验请求失败')
    }

    const data = await response.json()

    if (!data.result) {
      ElMessage({
        message: data.errorText || '规则校验失败',
        type: 'error',
        center: true,
        duration: 8000,
        showClose: true,
        offset: 30,
        customClass: 'custom-message',
        round: true
      })
    }

    return data.result
  } finally {
    loading.close()
  }
}

// 修改重写函数
const handleRewrite = async (field,title) => {
  let loading = null
  try {
    const content = formData.value[field]
    if (!content) {
      ElMessage.warning('请先输入内容')
      return
    }

    // 添加内容校验
    const isValid = await validateContent(field, content)
    if (!isValid) {
      return
    }
    loading = ElLoading.service({
      lock: true,
      text: '正在重写内容...',
      background: 'rgba(255, 255, 255, 0.7)'
    })

    emit('generating-status', { field, status: true })

    // 使用 POST 请求
    const response = await fetch('/api/writing/refine', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify({
        content,
        action: 'rewrite',
        field
      })
    })

    if (!response.ok) {
      throw new Error('重写请求失败')
    }

     // 收到响应后就关闭 loading
     loading.close()

    let accumulatedContent = ''
    let reasoningContent = ''
    const reader = response.body.getReader()

    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        emit('generating-status', { field, status: false, success: true })
        emit('reason-status', { field, status: false, success: true })
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') continue
          try {
            const data = JSON.parse(jsonStr)
            if (data.result) {
              // 每次只添加新的内容
              accumulatedContent += data.result
              // 使用 nextTick 确保视图更新
              await nextTick(() => {
                formData.value[field] = accumulatedContent
                emit('update:modelValue', { ...formData.value })
                emit('field-modified', field)
                emit('reason-status', { field, status: false })
              })
            } else if (data.reasoning) {
              reasoningContent += data.reasoning
              formData.value[field] = ''
              await nextTick(() => {
                emit('reason-update', { key: field, value: reasoningContent })
                emit('reason-status', { field, status: true })
              })
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }

    if (accumulatedContent && !/^ERROR: /g.test(accumulatedContent)) {
      await fetchSaveActionValue({
        projectId: props.projectId,
        orgValue: content,
        praiseValue: accumulatedContent,
        type: 1, // 1: 重写 2:润色
        step: props.currentStep + 1,
        pos: field,
      })
      await fetchRecordAdd({
        projectId: props.projectId,
        opType: "AI_EDIT",
        stepName: currentStepList[props.currentStep],
        stepCode: currentStepEng[props.currentStep],
        blockCode: field,
        blockName: title,
        source: "ai",
        description: "AI编辑了",
        opDetail: JSON.stringify({
          oldContent: content,
          newContent: accumulatedContent,
        }),
      })
    }

    ElMessage.success('重写完成')

    
  } catch (error) {
    console.error('重写失败:', error)
    ElMessage.error('重写失败，请稍后重试')
  } finally {
    if (loading) {
      loading.close()
    }
    emit('generating-status', { field, status: false })
  }
}

const handlePolish = async (field,title) => {
  let loading = null
  try {
    const content = formData.value[field]
    if (!content) {
      ElMessage.warning('请先输入内容')
      return
    }

    // 添加内容校验
    const isValid = await validateContent(field, content)
    if (!isValid) {
      return
    }

    loading = ElLoading.service({
      lock: true,
      text: '正在润色内容...',
      background: 'rgba(255, 255, 255, 0.7)'
    })

    emit('generating-status', { field, status: true })

    // 使用 POST 请求
    const response = await fetch('/api/writing/refine', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify({
        content,
        action: 'polish',
        field
      })
    })

    if (!response.ok) {
      throw new Error('润色请求失败')
    }

    // 收到响应后就关闭 loading
    loading.close()

    let accumulatedContent = ''
    let reasoningContent = ''
    const reader = response.body.getReader()

    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        emit('generating-status', { field, status: false, success: true })
        emit('reason-status', { field, status: false, success: true })
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') continue
          try {
            const data = JSON.parse(jsonStr)
            if (data.result) {
              // 每次只添加新的内容
              accumulatedContent += data.result
              // 使用 nextTick 确保视图更新
              await nextTick(() => {
                formData.value[field] = accumulatedContent
                emit('update:modelValue', { ...formData.value })
                emit('field-modified', field)
                emit('reason-status', { field, status: false })
              })
            } else if (data.reasoning) {
              reasoningContent += data.reasoning
              formData.value[field] = ''
              await nextTick(() => {
                emit('reason-update', { key: field, value: reasoningContent })
                emit('reason-status', { field, status: true })
              })
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }

    if (accumulatedContent && !/^ERROR: /g.test(accumulatedContent)) {
      await fetchSaveActionValue({
        projectId: props.projectId,
        orgValue: content,
        praiseValue: accumulatedContent,
        type: 2, // 1: 重写 2:润色
        step: props.currentStep + 1,
        pos: field,
        description: "AI润色技术方案内容",
      })
      await fetchRecordAdd({
        projectId: props.projectId,
        opType: "AI_EDIT",
        stepName: currentStepList[props.currentStep],
        stepCode: currentStepEng[props.currentStep],
        blockCode: field,
        blockName: title,
        source: "ai",
        description: "AI编辑了",
        opDetail: JSON.stringify({
          oldContent: content,
          newContent: accumulatedContent,
        }),
      })
    }

    ElMessage.success('润色完成')
    
  } catch (error) {
    console.error('润色失败:', error)
    ElMessage.error('润色失败，请稍后重试')
  } finally {
    if (loading) {
      loading.close()
    }
    emit('generating-status', { field, status: false })
  }
}

// 点赞
const handleLike = async (field) => {
  try {
    const content = formData.value[field]
    if (!content) {
      ElMessage.warning('请先输入内容')
      return
    }

    const res = await fetchLike({
      type: 1,
      projectId: props.projectId,
      praiseValue: content,
      step: props.currentStep + 1,
      pos: field,
    })

    if (res) {
      ElMessage.success('点赞成功')
    }
  } catch (error) {
    console.error('点赞失败:', error)
    ElMessage.error('点赞失败，请稍后重试')
  }
}

const handleSelectAI = ({ content, field }) => {
  formData.value[field] = content
  emit('update:modelValue', { ...formData.value })
  emit('field-modified', field, true)
}

const isRecognizing = ref(false)

const handleRemoveImage = (index) => {
  const current = formData.value.imageUrls[index]
  if (!current.id) return false

  return fetchDeleteFile([current.id]).then(res => {
    if (res) {
      // 从imageUrls数组中移除对应的URL
      formData.value.imageUrls.splice(index, 1)
      emit('update:modelValue', formData.value)
      emit('field-modified', 'imageUrls', true)
      return true
    }
    return false
  })
}

const currentConfirmButton = ref('technical') // 初始显示在技术方案上

const flowOrder = {
  'technical': 'effect',
  'effect': 'implementation',
  'implementation': 'background',
  'description': 'background',
  'background': null,
  'problem': null
}

const isStreamingField = (field) => {
  return props.generatingFields?.[field]
}

const isAIVisible = (field) => {
  // 查看模式不展示按钮
  if (props.disabled) return false
  // 如果字段正在流式打印，不显示任何按钮
  if (isStreamingField(field)) return false
  // 如果不是要点提纲步骤，不显示按钮
  if (!props.isOutlineStep) return false

  return Boolean(formData.value[field])
}

const isButtonVisible = (field) => {
  // 查看模式不展示按钮
  if (props.disabled) return false
  // 一键生成不展示撰写按钮
  if (props.isAuto) return false
  // 如果有字段正在流式打印，不显示任何按钮
  if (isStreamingField(field)) return false

  // 如果不是要点提纲步骤，不显示按钮
  if (!props.isOutlineStep) return false

  if (!expandProp.value[field]) return false

  if (!formData.value[field]) return false

  // 背景技术和技术问题不显示按钮
  if (field === 'background' || field === 'problem') return false

  // 处理同组显示情况
  if (currentConfirmButton.value === 'implementation' && field === 'description' && !isStreamingField('implementation')) return true
  if (currentConfirmButton.value === 'description' && field === 'implementation' && !isStreamingField('description')) return true

  return field === currentConfirmButton.value
}

// 修改滚动函数
const scrollToField = (field) => {
  if (field.value) {
    // 触发自定义事件，让父组件处理滚动
    emit('scroll-to', field.value)
  }
}

const handleConfirmAndContinue = async (field) => {
  const commonBody = props.getStepParams()
  // 如果是技术方案，调用有益效果接口
  if (field === 'technical') {
    try {
      // 自动展开有益效果区域
      expandProp.value.effect = true
      currentConfirmButton.value = ''
      emit('generating-status', { field: 'effect', status: true })

      // 滚动到有益效果字段
      scrollToField(effectField)

      if (generateAbortController.value.effect) {
        generateAbortController.value.effect.abort()
      }

      generateAbortController.value.effect = new AbortController()

      const response = await fetch('/api/draft/effect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream'
        },
        body: JSON.stringify({
          solution: formData.value.technical,
          effect: props.savedFormData?.effect || '',  // 使用savedFormData中的值
          background: formData.value.background,
          problem: formData.value.problem,
          ...commonBody,
        }),
        signal: generateAbortController.value.effect.signal
      })

      if (!response.ok) {
        throw new Error('有益效果生成请求失败')
      }

      if (generateAbortController.value.effect?.signal.aborted) {
        return
      }

      // 处理流式响应
      let accumulatedContent = ''
      let reasoningContent = ''
      const reader = response.body.getReader()

      while (true) {
        const { done, value } = await reader.read()
        if (generateAbortController.value.effect?.signal.aborted) {
          break
        }
        if (done) {
          currentConfirmButton.value = 'effect'
          emit('generating-status', { field: 'effect', status: false, success: true })
          emit('reason-status', { field: 'effect', status: false, success: true })
          break
        }

        // 将 Uint8Array 转换为文本
        const chunk = new TextDecoder().decode(value)
        const lines = chunk.split('\n')

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const jsonStr = line.slice(5).trim()
            if (jsonStr === '[DONE]') continue
            try {
              const data = JSON.parse(jsonStr)
              if (data.result) {
                accumulatedContent += data.result
                await nextTick(() => {
                  formData.value.effect = accumulatedContent
                  emit('update:modelValue', { ...formData.value })
                  emit('field-modified', 'effect')
                  emit('reason-status', { field, status: false })
                })
              } else if (data.reasoning) {
                reasoningContent += data.reasoning
                formData.value.effect = ''
                await nextTick(() => {
                  emit('reason-update', { key: 'effect', value: reasoningContent })
                  emit('reason-status', { field: 'effect', status: true })
                })
              }
            } catch (e) {
              console.warn('解析 SSE 数据失败:', e)
            }
          }
        }
      }

      // 有益效果生成完成后，显示其"确认并继续撰写"按钮
      currentConfirmButton.value = 'effect'
      return
    } catch (error) {
      emit('generating-status', { field: 'effect', status: false })
      if (error.name === 'AbortError') {
        console.log('请求被取消')
        return
      }
      console.error('有益效果生成失败:', error)
      ElMessage.error('有益效果生成失败，请重试')
    } finally {
      // 清理 AbortController
      generateAbortController.value.effect = null
    }
  }

  // 如果是有益效果，同时调用具体实施方式和附图说明接口
  if (field === 'effect') {
    try {
      // 自动展开具体实施方式和附图说明区域
      expandProp.value.implementation = true
      expandProp.value.description = true
      currentConfirmButton.value = ''

      // 滚动到具体实施方式字段
      scrollToField(implementationField)

      const apiCalls = []
      console.log('formData.value', formData.value, props.savedFormData)
      // 如果有具体实施方式的值，添加具体实施方式接口调用
      if (props.savedFormData?.implementation) {
        apiCalls.push({
          url: '/api/draft/implementation',
          field: 'implementation',
          body: {
            solution: formData.value.technical,
            effect: formData.value.effect,
            implementation: props.savedFormData?.implementation || '',  // 使用savedFormData中的值
            background: formData.value.background,
            problem: formData.value.problem,
            ...commonBody,
          }
        })
      }

      // 如果有附图说明的值，添加附图说明接口调用
      if (props.savedFormData?.description) {
        apiCalls.push({
          url: '/api/draft/drawings',
          field: 'description',
          body: {
            description: props.savedFormData?.description || '',  // 使用savedFormData中的值
            solution: formData.value.technical,
            effect: formData.value.effect,
            ...commonBody,
          }
        })
      }

      if (props.savedFormData?.imageUrls) {
        props.savedFormData?.imageUrls?.forEach((image, index) => {
          apiCalls.push({
            url: '/api/draft/drawings',
            field: 'imageUrls',
            fieldIndex: index,
            body: {
              description: image.content || '',
              solution: formData.value.technical,
              effect: formData.value.effect,
              ...commonBody,
            }
          })
        })
      }

      // 并行调用接口
      const apiPromises = apiCalls.map(async ({ url, field, body, fieldIndex }) => {
        try {
          emit('generating-status', { field, status: true })

          let fieldAbort = generateAbortController.value[field]
          if (field === 'imageUrls') {
            generateAbortController.value[field] = generateAbortController.value[field] || []
            fieldAbort = generateAbortController.value[field][fieldIndex]
          }

          if (fieldAbort) {
            fieldAbort.abort()
          }

         fieldAbort = new AbortController()

          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'text/event-stream'
            },
            body: JSON.stringify(body),
            signal: fieldAbort.signal
          })

          if (!response.ok) {
            throw new Error(`${field} 接口调用失败`)
          }

          if (fieldAbort?.signal.aborted) {
            return
          }
          // 处理流式响应
          let accumulatedContent = ''
          let reasoningContent = ''
          const reader = response.body.getReader()

          while (true) {
            const { done, value } = await reader.read()
            if (fieldAbort?.signal.aborted) {
              break
            }
            if (done) {
              currentConfirmButton.value = 'implementation'
              // 重置当前字段的生成状态
              emit('generating-status', { field, status: false, success: true })
              emit('reason-status', { field, status: false, success: true })
              break
            }

            const chunk = new TextDecoder().decode(value)
            const lines = chunk.split('\n')

            for (const line of lines) {
              if (line.startsWith('data: ')) {
                const jsonStr = line.slice(5).trim()
                if (jsonStr === '[DONE]') continue
                try {
                  const data = JSON.parse(jsonStr)
                  if (data.result) {
                    accumulatedContent += data.result
                    await nextTick(() => {
                      if (field === 'imageUrls') {
                        formData.value[field][fieldIndex].content = accumulatedContent
                      } else {
                        formData.value[field] = accumulatedContent
                      }
                      emit('update:modelValue', { ...formData.value })
                      emit('field-modified', field)
                      emit('reason-status', { field, status: false })
                    })
                  } else if (data.reasoning) {
                    reasoningContent += data.reasoning
                    formData.value[field] = ''
                    await nextTick(() => {
                      emit('reason-update', { key: field, value: reasoningContent })
                      emit('reason-status', { field, status: true })
                    })
                  }
                } catch (e) {
                  console.warn('解析 SSE 数据失败:', e)
                }
              }
            }
          }
          currentConfirmButton.value = 'implementation'
          return true
        } catch (error) {
          console.error(`${field} 接口调用失败:`, error)
          // 在错误时也要重置生成状态
          emit('generating-status', { field, status: false })
          return false
        }
      })

      // 等待所有接口完成
      await Promise.all(apiPromises)
      return
    } catch (error) {
      emit('generating-status', { field: 'implementation', status: false })
      emit('generating-status', { field: 'description', status: false })
      if (error.name === 'AbortError') {
        console.log('请求被取消')
        return
      }
      console.error('生成失败:', error)
      ElMessage.error('生成失败，请重试')
    } finally {
      generateAbortController.value.implementation = null
      generateAbortController.value.description = null
    }
  }

  // 如果是具体实施方式或附图说明，滚动到背景技术
  if (field === 'implementation' || field === 'description') {
    const okFields = []
    try {
      // 自动展开背景技术和技术问题区域
      expandProp.value.background = true
      expandProp.value.problem = true
      currentConfirmButton.value = ''
      // 设置生成状态
      emit('generating-status', { field: 'background', status: true })
      emit('generating-status', { field: 'problem', status: true })

      // 滚动到背景技术字段
      scrollToField(backgroundField)

      const apiCalls = [
        {
          url: '/api/draft/background',
          field: 'background',
          body: {
            background: props.savedFormData?.background || '',
            solution: formData.value.technical,
            effect: formData.value.effect,
            implementation: formData.value.implementation,
            ...commonBody,
          }
        },
        {
          url: '/api/draft/problem',
          field: 'problem',
          body: {
            problem: props.savedFormData?.problem || '',
            background: props.savedFormData?.background || '',
            solution: formData.value.technical,
            effect: formData.value.effect,
            implementation: formData.value.implementation,
            ...commonBody,
          }
        },
        {
          url: '/api/draft/termInterpretation',
          field: 'termInterpretation',
          body: {
            problem: props.savedFormData?.problem || '',
            background: props.savedFormData?.background || '',
            solution: formData.value.technical,
            effect: formData.value.effect,
            implementation: formData.value.implementation,
            ...commonBody,
          }
        }
      ]

      // 用于跟踪完成的API调用数量
      let completedApiCalls = 0
      const totalApiCalls = apiCalls.length

      // 并行调用接口
      const apiPromises = apiCalls.map(async ({ url, field, body }) => {
        try {

          if (generateAbortController.value[field]) {
            generateAbortController.value[field].abort()
          }

          generateAbortController.value[field] = new AbortController()
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'text/event-stream'
            },
            body: JSON.stringify(body),
            signal: generateAbortController.value[field].signal
          })

          if (!response.ok) {
            throw new Error(`${field} 接口调用失败`)
          }

          if (generateAbortController.value[field]?.signal.aborted) {
            return
          }

          // 处理流式响应
          let accumulatedContent = ''
          let reasoningContent = ''
          const reader = response.body.getReader()

          while (true) {
            const { done, value } = await reader.read()
            if (generateAbortController.value[field]?.signal.aborted) {
              break
            }
            if (done) {
              completedApiCalls++
              currentConfirmButton.value = 'background'
              // 立即重置当前字段的状态
              emit('generating-status', { field, status: false, success: true })
              emit('reason-status', { field, status: false, success: true })

              generateAbortController.value.background = null
              generateAbortController.value.problem = null

              // 当所有API调用完成时调用评分接口
              if (completedApiCalls === totalApiCalls) {
                // 调用评分接口
                fetchScores(formData.value)
                emit('save-model')
              }
              okFields.push(field)
              break
            }

            const chunk = new TextDecoder().decode(value)
            const lines = chunk.split('\n')

            for (const line of lines) {
              if (line.startsWith('data: ')) {
                const jsonStr = line.slice(5).trim()
                if (jsonStr === '[DONE]') continue
                try {
                  const data = JSON.parse(jsonStr)
                  if (data.result) {
                    accumulatedContent += data.result
                    await nextTick(() => {
                      formData.value[field] = accumulatedContent
                      emit('update:modelValue', { ...formData.value })
                      emit('field-modified', field)
                      emit('reason-status', { field, status: false })
                    })
                  } else if (data.reasoning) {
                    reasoningContent += data.reasoning
                    formData.value[field] = ''
                    await nextTick(() => {
                      emit('reason-update', { key: field, value: reasoningContent })
                      emit('reason-status', { field, status: true })
                    })
                  }
                } catch (e) {
                  console.warn('解析 SSE 数据失败:', e)
                }
              }
            }
          }
          currentConfirmButton.value = 'background'

          return true
        } catch (error) {
          console.error(`${field} 接口调用失败:`, error)
          completedApiCalls++
          // 在错误时也要重置生成状态
          emit('generating-status', { field, status: false })
          return false
        }
      })

      // 等待所有接口完成
      await Promise.all(apiPromises)
      if (okFields.length === 2 && !props.isAuto) {
        ElMessage.success('初版生成成功')
      }
      return
    } catch (error) {
      emit('generating-status', { field, 'background': false })
      emit('generating-status', { field, 'problem': false })
      if (error.name === 'AbortError') {
        console.log('请求被取消')
        return
      }
      console.error('生成失败:', error)
      ElMessage.error('生成失败，请重试')
    }
  }

  // 获取下一个要显示的位置
  const nextField = flowOrder[field]

  // 如果有下一个位置，则移动按钮
  if (nextField) {
    currentConfirmButton.value = nextField
    // 自动展开下一个区域
    expandProp.value[nextField] = true

    // 如果是同组的，也要展开
    if (nextField === 'implementation') {
      expandProp.value.description = true
    } else if (nextField === 'background') {
      expandProp.value.problem = true
    }
  }
}

/**
 * 异步获取评分
 * @param {Object} content - 需要评分的内容
 */
const fetchScores = async (content) => {
  try {
    // 如果有正在进行的评分请求，取消它
    if (scoreAbortController.value) {
      scoreAbortController.value.abort()
    }

    // 创建新的 AbortController
    scoreAbortController.value = new AbortController()
    const response = await fetch('/api/score', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ content, step: 2, step1_content: props.getStepParams().step1 }),
      signal: scoreAbortController.value.signal
    })

    if (!response.ok) {
      throw new Error('评分请求失败')
    }

    const data = await response.json()

    // 如果请求已经被取消，不更新scores
    if (scoreAbortController.value?.signal.aborted) {
      return
    }

    // 检查返回的数据结构并更新scores
    if (data.code === 0 && data.content) {
      const content = data.content
      // 将API返回的评分数据映射到ScorePanel组件需要的格式
      const scores = {
        ...content,
        overall: {
          ...content.overall,
          comments: content.overall.comments.map((comment, index) => `${index + 1}. ${comment}`).join('\n')
        },
        background: {
          ...content.background,
          comments: content.background.comments.map((comment, index) => `${index + 1}. ${comment}`).join('\n')
        },
        solution: {
          ...content.solution,
          comments: content.solution.comments.map((comment, index) => `${index + 1}. ${comment}`).join('\n')
        },
        effect: {
          ...content.effect,
          comments: content.effect.comments.map((comment, index) => `${index + 1}. ${comment}`).join('\n')
        }
      }
      // 触发评分更新事件，传递完整的评分数据
      emit('score-update', scores)
    }
  } catch (error) {
    console.error('获取评分失败:', error)
    // 评分失败不影响主流程,只在控制台打印错误
  } finally {
    // 清理 AbortController
    scoreAbortController.value = null
  }
}

const stopScore = () => {
  if (scoreAbortController.value) {
    scoreAbortController.value.abort()
    scoreAbortController.value = null
  }
  if (generateAbortController.value) {

    Object.keys(generateAbortController.value).forEach(field => {
      if (generateAbortController.value[field]) {
        generateAbortController.value[field].abort()
        generateAbortController.value[field] = null
      }
    })
  }
}

const handleHistoryUpdate = () => {
  emit('history-update')
}
// 修改 streamingFields 的 watch
// watch(streamingFields.value, (newVal) => {
//   // 通知父组件当前的流式打印状态, 只要有一个在打印就返回true
//   const status = Object.values(newVal).some(v => v)
//   emit('streaming-status', status)
// }, { deep: true })

eventBus.on("aiModify",(val)=>{
  showAIPanel.value = val.field
  // 使用封装的方法设置 inputValue
  AIAssistantRef.value?.setInputValue(val.sentenceText)
})


// 处理弹框关闭
const handleDialogClose = () => {
  showMermaidDialog.value = false
}



// 生成Mermaid流程图
const handleGenerateMermaid = async () => {
  const descriptionContent = formData.value.description
  if (!descriptionContent || !descriptionContent.trim()) {
    ElMessage.warning('请先输入附图及简要说明内容')
    return
  }

  // 直接打开弹框，由MermaidDialog组件处理生成和渲染
  showMermaidDialog.value = true
}

const handleMermaidSave = async (data) => {
  try {
    // 更新简要说明
    formData.value.description = data.description || '流程图：基于技术方案自动生成';

    // 创建符合FileUploadSection格式的图片对象
    const newImage = {
      url: data.imageUrl,
      content: data.mermaidCode,
      id: data.imageId || Date.now().toString(),
      loading: false,
      name: `flowchart_${Date.now()}.jpg`,  // 增加文件名
      size: 0,  // 可以根据实际情况计算
      type: 3,  // 3表示图片类型（与FileUploadSection保持一致）
      uid: `mermaid_${Date.now()}`  // 增加唯一标识
    };

    // 添加到图片列表
    formData.value.imageUrls.push(newImage);

    // 通知父组件更新
    emit('update:modelValue', { ...formData.value });
    emit('field-modified', 'description', true);
    emit('field-modified', 'imageUrls', true);

    // 执行与FileUploadSection相同的图片识别流程
    // 注意：判断条件要和真正传出去的字段一致（传的是 url，不是 imageId）
    if (data.imageId) {
      if (!newImage.url) {
        console.warn('[识别图片] 流程图已保存，但返回里没有图片地址（imageUrl 为空）', {
          imageId: data.imageId,
          imageUrl: data.imageUrl,
          hasProjectId: !!props.projectId
        });
      }
      const imageIndex = formData.value.imageUrls.length - 1;
      await handleRecognizeImage(newImage, imageIndex);
    }

    ElMessage.success('流程图已成功保存为JPG并开始分析');
  } catch (error) {
    console.error('保存流程图失败:', error);
    ElMessage.error('保存失败: ' + error.message);
  }
};


// 添加图片识别方法
const handleRecognizeImage = async (file, index) => {
  // 兜底告警：没拿到图片地址时照样发一次请求，让后端记录原始请求（以前是静默失败）
  if (!file?.url) {
    console.warn('[识别图片] 没有拿到图片地址（imagePath 为空）', {
      index,
      fileId: file?.id,
      fileName: file?.name,
      file
    });
    ElMessage.warning('没有拿到图片地址，图片识别可能失败（已记录日志）');
  }
  try {
    emit('generating-status', { field: 'imageUrls', status: true });

    const recognizeResponse = await fetch('/api/outline/recognize-image', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        imagePath: file.url,
        description: formData.value.description || ''
      })
    });

    if (!recognizeResponse.ok) {
      throw new Error('图片识别请求失败');
    }

    // 读取流式响应
    const reader = recognizeResponse.body.getReader();
    let accumulatedContent = formData.value.description || '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim();
          if (jsonStr === '[DONE]') continue;
          try {
            const data = JSON.parse(jsonStr);
            if (data.result) {
              // 每次只添加新的内容
              accumulatedContent += data.result;
              // 使用 nextTick 确保视图更新
              await nextTick(() => {
                formData.value.imageUrls[index].content = accumulatedContent;
                emit('update:modelValue', { ...formData.value });
                emit('field-modified', 'description');
              });
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e);
          }
        }
      }
    }

  } catch (error) {
    console.error('图片识别失败:', error);
    ElMessage.warning('图片识别失败，但不影响图片显示');
  } finally {
    // 无论成功失败都关闭loading
    emit('generating-status', { field: 'imageUrls', status: false });
  }
};


defineExpose({
  handleConfirmAndContinue,
  stopScore,
  fetchScores,
  isComplete: () => !isButtonVisible('technical') && !isButtonVisible('effect') && !isButtonVisible('implementation') && !isButtonVisible('description'),
  getAIHistory: () => AIAssistantRef.value.allFieldHistory,
  setAIHistory: (val) => AIAssistantRef.value.setAllFieldHistory(val),
  getConfirmButton: () => currentConfirmButton.value,
  setConfirmButton: (button) => { currentConfirmButton.value = button }
})
</script>

<style scoped lang="scss">
.collapsible-section {
  position: relative;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

.collapsible-header {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: rgba(0,161,96,0.06);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.extract-file {
  position: absolute;
  top: 20%;
  left: -70px;
  padding: 10px 0;
  background: #fff;
  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 80px;
    word-break: break-word;
    &::before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      min-width: 10px;
      border-radius: 50%;
    }
    &:nth-child(8n + 1)::before {
      background: rgba(255,0,0,0.15);
    }
    &:nth-child(8n + 2)::before {
      background: #FFE893;
    }
    &:nth-child(8n + 3)::before {
      background: #FBB4A5;
    }
    &:nth-child(8n + 4)::before {
      background: #FB9EC6;
    }
    &:nth-child(8n + 5)::before {
      background: #FFCF9D;
    }
    &:nth-child(8n + 6)::before {
      background: #DE8F5F;
    }
    &:nth-child(8n + 7)::before {
      background: #C4E1F6;
    }
    &:nth-child(8n)::before {
      background: #FFF0DC;
    }
  }
}

.header-left {
  display: flex;
  align-items: center;
  .header-arrow {
    transform: rotate(-90deg);
    transform-origin: center center;
  }
}

.header-title {
  font-weight: 600;
  color: var(--el-text-color-primary);
}

.header-tip {
  margin-left: 16px;
  font-size: 12px;
  color: #666;
}

.field-count {
  display: none;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #F1F5F9;
  color: #64748B;
  font-weight: normal;
}

.collapsible-content {
  max-height: 0;
  padding-left: 24px;
  overflow: hidden;
  transition: all 0.3s ease-out;
  opacity: 0;
}

.collapsible-content.expanded {
  max-height: none;
  opacity: 1;
  padding-top: 16px;
}

.form-item {
  position: relative;
  height: 32px;
  overflow: hidden;
  border: 1px solid #E1E1E1;
  border-radius: 4px;
  label {
    height: 32px;
    display: flex;
    align-items: center;
    font-weight: 600;
    color: var(--el-text-color-regular);
    cursor: pointer;
    .label-arrow {
      transform: rotate(-90deg);
      transform-origin: center center;
    }
    .required {
      color: #FF3B30;
      margin-left: 4px;
    }
    .reason {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      padding: 2px 10px;
      margin-left: 8px;
      font-weight: 400;
      color: #333;
      background: #eee;
      border-radius: 6px;
    }
  }
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  &.error {
    border-color: #FF3B30;
  }
  &.expand {
    height: auto;
    padding-bottom: 16px;
    transition: all 0.3s;
    label {
      margin-bottom: 8px;
      .label-arrow {
        transform: none;
      }
    }
  }
}

.reason-text {
  width: calc(100% - 50px);
  margin: 0 25px 16px;
  padding-left: 10px;
  color: #999;
  border-left: 2px solid #d5d5d5;
  box-sizing: border-box;
}

.textarea-wrapper {
  width: 100%;
  display: flex;
  position: relative;
}

.confirm-button {
  position: absolute;
  bottom: -12px;
  right: 8px;
  padding: 6px 16px;
  background: var(--el-color-primary);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  line-height: 1.4;
  font-weight: 500;

  &:hover {
    background: var(--el-color-primary-dark-2);
  }
}

.form-item:hover .hover-panel {
  opacity: 1;
  pointer-events: auto;
}

.hover-panel {
  position: absolute;
  top: 2px;
  right: 12px;
  z-index: 1000;
  display: flex;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
}

.hover-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  border: none;
  border-radius: 2px;
  font-weight: 500;
  font-size: 12px;
  font-family: PingFang SC;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  background: none;
  .hover-btn-icon-active {
    display: none;
  }
}

.hover-btn:hover {
  color: var(--el-color-primary);
  background: rgba(0,161,96,0.06);
  .hover-btn-icon {
    display: none;
  }
  .hover-btn-icon-active {
    display: block;
  }
}

textarea {
  width: 100%;
  padding: 0 25px;
  line-height: 20px;
  resize: none;
  transition: all 0.3s ease;
  min-height: 60px;
  height: auto;
  overflow: hidden;
  color: #444;
  font-family: PingFang SC;
  font-size: 14px;
  border: none;
}
textarea:disabled::placeholder {
  opacity: 0
}
textarea::placeholder {
  color: #999;
}
textarea:focus {
  outline: none;
  box-shadow: none;
}

.upload-demo {
  padding-left: 0;
}

:deep(.el-upload--picture-card) {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background: #EFEFEF;
  border-radius: 4px;
  border: none;
  .el-icon {
    font-size: 20px;
  }
  &:hover .el-icon {
    color: var(--el-text-color-primary);
  }
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 50px;
  height: 50px;
  .el-upload-list__item-actions {
    font-size: 16px;
    span + span {
      margin-left: 6px;
    }
  }
}

.el-dialog img {
  max-width: 100%;
  height: auto;
}

:deep(.el-upload-list__item) {
  .el-upload-list__item-status-label {
    display: none !important;  // 隐藏状态标签（绿色对号）
  }
  .el-icon--close-tip {
    display: none !important;
  }
  &.is-uploading {
    .el-upload-list__item-actions {
      display: none;
    }
  }
  &.is-success {
    .el-upload-list__item-status-label {
      display: none !important;
    }
  }
}

.upload-section {
  min-height: 50px;
  color: #444;
  .upload-image {
    position: relative;
    display: flex;
    flex-direction: column;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .image-title {
    margin-left: 25px;
    font-weight: bold;
  }
  .image-item {
    position: relative;
    width: 50px;
    height: 50px;
    margin-left: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #EFEFEF;
    border-radius: 4px;
    :deep(.el-image) {
      width: 100%;
      height: 100%;
    }
    .image-close {
      display: none;
      position: absolute;
      top: -5px;
      right: -5px;
      z-index: 10;
      color: var(--el-color-info);
      font-size: 16px;
      cursor: pointer;
      &:hover {
        color: rgb(156, 159, 164)
      }
    }
    &:hover {
      .image-close {
        display: block;
      }
    }
  }
}

:deep(.el-loading-spinner) {
  .el-loading-text {
    color: var(--el-color-primary);
    font-size: 13px;
  }
  .path {
    stroke: var(--el-color-primary);
  }
}

// Mermaid相关样式
.mermaid-section {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  // background: #f8f9fa;
  // border: 1px solid #e9ecef;
  border-radius: 6px;
}

.mermaid-generate-btn,
.mermaid-test-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #67c23a;
  border-radius: 4px;
  background: #ecf5ff;
  color: #67c23a;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto;

  &:hover:not(:disabled) {
    background: #67c23a;
    color: white;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.mermaid-test-btn {
  border-color: #67c23a;
  background: #f0f9ff;
  color: #67c23a;

  &:hover {
    background: #67c23a;
    color: white;
  }
}

.mermaid-display {
  margin-top: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
}

.mermaid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.mermaid-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.mermaid-actions {
  display: flex;
  gap: 8px;
}

.mermaid-copy-btn,
.mermaid-clear-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: 1px solid #d9ecff;
  border-radius: 3px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #409eff;
    color: white;
  }
}

.mermaid-clear-btn {
  border-color: #fbc4c4;
  background: #fef0f0;
  color: #f56c6c;

  &:hover {
    background: #f56c6c;
    color: white;
  }
}

.mermaid-content {
  padding: 16px;
}

.mermaid-diagram {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  margin-bottom: 16px;
  background: #fafafa;
}

.mermaid-placeholder {
  color: #999;
  font-size: 14px;
  text-align: center;
}

.mermaid-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
}

.mermaid-error {
  color: #f56c6c;
  text-align: center;
  padding: 20px;

  .error-detail {
    margin: 8px 0;
    font-size: 12px;
  }
}

.mermaid-code-section {
  border-top: 1px solid #e4e7ed;
  padding-top: 16px;
}

.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.code-title {
  font-size: 13px;
  font-weight: 500;
  color: #606266;
}

.toggle-code-btn {
  padding: 4px 8px;
  border: 1px solid #d9ecff;
  border-radius: 3px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #409eff;
    color: white;
  }
}

.mermaid-code-wrapper {
  background: #f5f5f5;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

.mermaid-code {
  margin: 0;
  padding: 12px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  line-height: 1.5;
  overflow-x: auto;
}

// 测试按钮样式
.chart-container {
  min-height: 200px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 16px;
  margin-top: 16px;
}

// Mermaid弹框样式
:deep(.mermaid-dialog) {
  .el-dialog__body {
    padding: 0;
  }
}

.mermaid-dialog-content {
  padding: 20px;
}

.mermaid-toolbar {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.mermaid-display-area {
  min-height: 400px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}

.mermaid-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.mermaid-error {
  padding: 40px 20px;
}

.mermaid-diagram-container {
  min-height: 400px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;

  :deep(svg) {
    max-width: 100%;
    height: auto;
  }
}

.mermaid-code-collapse {
  margin-top: 20px;
}

.mermaid-code-input {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;

  :deep(textarea) {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    line-height: 1.5;
  }
}
</style>
